import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var QuestionSummary = /*#__PURE__*/function (_Entity) {
  _inherits(QuestionSummary, _Entity);

  var _super = _createSuper(QuestionSummary);

  function QuestionSummary() {
    _classCallCheck(this, QuestionSummary);

    return _super.apply(this, arguments);
  }

  _createClass(QuestionSummary, [{
    key: "tyoe",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.props.sectionId;
    }
  }, {
    key: "formId",
    get: function get() {
      return this.props.formId;
    }
  }, {
    key: "score",
    get: function get() {
      return this.props.score;
    }
  }, {
    key: "previousQuestionId",
    get: function get() {
      return this.props.previousQuestionId;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
    }
  }, {
    key: "updateScore",
    value: function updateScore(score) {
      this.props.score = score;
    }
  }, {
    key: "updateSectionId",
    value: function updateSectionId(sectionId) {
      this.props.sectionId = sectionId;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.formId,
        argumentName: 'Form Id'
      }, {
        argument: props.sectionId,
        argumentName: 'Section Id'
      }, {
        argument: props.score,
        argumentName: 'Score Id'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new QuestionSummary(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "createFromQuestion",
    value: function createFromQuestion(question) {
      return QuestionSummary.create({
        id: question.id.toString(),
        sectionId: question.sectionId,
        score: question.score,
        description: question.description,
        formId: question.formId,
        previousQuestionId: question.previousQuestionId,
        index: question.index,
        type: question.type
      }).getValue();
    }
  }]);

  return QuestionSummary;
}(Entity);